// light mode
export const palette = {
  primary: {
    main: "#4700d7",
    dark: "#310096",
    light: "#6b33df",
    contrastText: "#fff",
  },
  secondary: {
    main: "#ef8175",
    dark: "#a75a51",
    light: "#f29a90",
    contrastText: "#fff",
  },
  info: {
    main: "#56c4e6",
    dark: "#3c89a1",
    light: "#77cfeb",
    contrastText: "#fff",
  },
  success: {
    main: "#03e1b9",
    dark: "#00d09c",
    light: "#92edd5",
    contrastText: "#000"
  },

  white: {
    main: "#fff",
    contrastText: "#fff",
  },

  tertiary: {
    main: "#fff",
    light: "#dedede"
  },

  common: {
    black: "#000",
    white: "#fff",
    red: "#bb2c1f",
  },
  supportiveDustyBlue: {
    main: "#1e0040",
    contrastText: "#fff",
  },
  supportiveBurgundy: {
    main: "#650043",
    contrastText: "#fff",
  },
  supportiveDarkGreen: {
    main: "#0a403c",
    contrastText: "#fff",
  },
  supportiveIndigoHover: {
    main: "#c8b2f3",
    contrastText: "#fff",
  },
  gray200: "#eef0f4",
  gray300: "#e0e2e6",
  gray500: "#9ea0a4",
  gray800: "#3c3e42",
};
